import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subject",
  "use": "icon-subject-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-subject\"><defs><style></style></defs><path d=\"M674.91 98.607l-325.82 88.855v737.931l325.82-88.855V98.607zM0 0l341.341 93.09L682.66 0 1024 93.09V1024l-341.341-93.09L341.34 1024 0 930.91V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol